import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Review.css";
import InnerHeader from "../../components/InnerHeader";
import Card from "../../components/Card";
import { AiFillPlusCircle } from "react-icons/ai";
import ImageGallery from "../../components/ImageGallery";
import { IoStar } from "react-icons/io5";
import ImageDropdown from "../../components/ImageDropdown";
import { GrFormPreviousLink, GrFormNextLink } from "react-icons/gr";
import { MdOutlineStarBorder, MdOutlineStar } from "react-icons/md";
import { FaStar } from "react-icons/fa";

import constant from "../../constant/constant";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SmallLoader from "../../components/SmallLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logout } from "../../store/authSlice.js";
import ThankYou from "../../components/ThankYou.js";

const Review = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth);
  const [reviewData, setReviewData] = useState({
    title: "",
    description: "",
    image: "",
  });
  const [rating, setRating] = useState(0);
  const [recommend, setRecommend] = useState(null);
  const [friendInfoList, setFriendInfoList] = useState([
    { name: "", email: "", mobile: "" },
    { name: "", email: "", mobile: "" },
    { name: "", email: "", mobile: "" },
  ]);
  const [selectedReviewTypes, setSelectedReviewTypes] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedCourseOptions, setSelectedCourseOptions] = useState([]);
  const [selectedCenterOptions, setSelectedCenterOptions] = useState([]);
  const pageUserTypeAccess = user.user_type;
  
  const [filterStatus, setFilterStatus] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);

  const [currentStep, setCurrentStep] = useState(0);
  const [questionRatings, setQuestionRatings] = useState([]);
  const [staffOptions, setStaffOptions] = useState([]);
  const [courseOptions, setCourseOptions] = useState([]);
  const [centerOptions, setCenterOptions] = useState([]);
  
  const [imageURL, setImageURL] = useState([]);
  const [submitLoader,setSubmitLoader] = useState(false);

  const ratingDetails = [
    {
      emoji: "😔",
      message:
        "We're sorry to hear this. Please let us know what went wrong so we can make things right.",
    },
    {
      emoji: "😕",
      message:
        "We see room for improvement. Let us know how we can better serve you.",
    },
    {
      emoji: "😐",
      message:
        "Thanks for your feedback! What could we do to earn a higher rating?",
    },
    {
      emoji: "😊",
      message:
        "We're glad you had a good experience! Any suggestions to make it even better?",
    },
    {
      emoji: "😄",
      message:
        "Thank you for your great rating! We'd love to hear what you enjoyed most or any ideas for further improvement",
    },
  ];

  const handleRatingClick = (index, rating) => {
    const updatedRatings = [...questionRatings];
    updatedRatings[index].rating = rating;
    setQuestionRatings(updatedRatings);
  };
  const handleStarClick = (starIndex) => {
    const updatedRatings = [...questionRatings];
    updatedRatings[currentStep].rating = starIndex + 1;
    setQuestionRatings(updatedRatings);
    if (currentStep < questionRatings.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };
  const handleBoxClick = (value) => {
    const updatedRatings = [...questionRatings];
    updatedRatings[currentStep].rating = value;
    setQuestionRatings(updatedRatings);
    if (currentStep < questionRatings.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleRateClick = (starIndex) => {
    setRating(starIndex + 1);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setReviewData((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleRecommendationChange = (value) => {
    setRecommend(value);
  };

  const handleFriendChange = (index, e) => {
    const { id, value } = e.target;
    const updatedFriendInfoList = [...friendInfoList];
    updatedFriendInfoList[index] = {
      ...updatedFriendInfoList[index],
      [id]: value,
    };
    setFriendInfoList(updatedFriendInfoList);
  };

  const addMoreFriends = () => {
    setFriendInfoList([...friendInfoList, { name: "", email: "", mobile: "" }]);
  };

  const handleReviewTypeChange = (value) => {
    setSelectedReviewTypes((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((type) => type !== value)
        : [...prevSelected, value]
    );
  };

  const handleSelectionChange = (selected) => {
    setSelectedOptions(selected);
  };

  const handleCourseSelectionChange = (selected) => {
    setSelectedCourseOptions(selected);
  }

  const handleCenterSelectionChange = (selected) => {
    setSelectedCenterOptions(selected);
  }

  const nextStep = () => {
    if (currentStep < questionRatings.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const getAllDataForm = async () => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/review_student.php?fun=getAllDataForm`,
      headers: {"Auth-Id": user.auth_id },
      data: { "id": user.userid}
    }).then(function (response) {
      checkUserLogin(response);
      const responseData = response.data.data.data;
      if (response.data.data.status === "1") {
        if (Array.isArray(responseData.questionData)) {
          setQuestionRatings(responseData.questionData);
        } else {
          setQuestionRatings([]);
        }
        if (Array.isArray(responseData.instructorData)) {
          setStaffOptions(responseData.instructorData);
        } else {
          setStaffOptions([]);
        }
        if (Array.isArray(responseData.courseData)) {
          setCourseOptions(responseData.courseData);
        } else {
          setCourseOptions([]);
        }
        if (Array.isArray(responseData.locationData)) {
          setCenterOptions(responseData.locationData);
        } else {
          setCenterOptions([]);
        }
        setFilterStatus(true);
      } else {
      }
    })
    .catch(function (error) {
    });
  }

  const validateForm = () => {
    let isValid = true;
  
    if (rating === 0) {
      toast.warn("Please provide a rating.");
      isValid = false;
    } 
    if (rating >= 0 && rating <= 4 && !reviewData.description) {
      //toast.warn("Description is required when rating is between 1 and 4.");
      toast.warn("Your suggestions for improvement are missing; please share your experience.");
      isValid = false;
    }

    questionRatings.forEach((question) => {
      if (question.mandatory_flag === "1" && question.rating === 0) {
          toast.warn(`Please provide an answer for Q${question.serial_no}- ${question.question}.`);
          isValid = false;
      }
    });
  
    /*if(user.otherdata.stage !== "free"){
      if (selectedReviewTypes.length === 0) {
        toast.warn("Please choose Review for course/center/instructor.");
        isValid = false;
      } else {
        if (selectedReviewTypes.includes("course") && (!courseOptions || courseOptions.length > 1)) {
          if(!selectedCourseOptions || selectedCourseOptions.length === 0){
            toast.warn("Course missing, please select from list.");
            return false;
          }
        }
      
        if (selectedReviewTypes.includes("instructor") && (!staffOptions || staffOptions.length > 0)) {
          if(!selectedOptions || selectedOptions.length === 0){
            toast.warn("Instructor missing, please select from list.");
            return false;
          }
        }
  
        if (selectedReviewTypes.includes("center") && (!centerOptions || centerOptions.length > 1)) {
          if(!selectedCenterOptions || selectedCenterOptions.length === 0){
            toast.warn("Center missing, please select from list.");
            return false;
          }
        }
      }
    }*/
  
    if (!recommend) {
      toast.warn("Confirm if you would like to recommend this to friends and colleagues.");
      isValid = false;
    }

    if (recommend === "yes") {
      let allFieldsEmpty = true;
      for (let i = 0; i < friendInfoList.length; i++) {
        const friend = friendInfoList[i];
        const isNameFilled = friend.name.trim() !== "";
        const isEmailFilled = friend.email.trim() !== "";
        const isMobileFilled = friend.mobile.trim() !== "";

        // if ((isNameFilled || isEmailFilled || isMobileFilled) && (!isNameFilled || !isEmailFilled || !isMobileFilled)) {
        //   toast.warn(`Please fill in all fields for Recommendation ${i + 1}.`);
        //   return false;
        // }
        if ((isNameFilled || isMobileFilled) && (!isNameFilled || !isMobileFilled)) {
          toast.warn(`Both name and mobile number are required for recommendation ${i + 1}.`);
          return false;
        }
        // if (isNameFilled || isEmailFilled || isMobileFilled) {
        //   allFieldsEmpty = false;
        // }
        if (isNameFilled || isMobileFilled) {
          allFieldsEmpty = false;
        }
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const isEmailValid = emailPattern.test(friend.email.trim());
if (isEmailFilled && !isEmailValid) {
          toast.warn("Please provide a valid email address for recommendation"+i+1+".");
          return false;
}     
      }
      if (allFieldsEmpty) {
        toast.warn("Please share at least one friend's information as a recommendation.");
        return false;
      }

    }
  
    return isValid;
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setSubmitLoader(true);
    const reviewInfo = {
      rating:rating,
      description:reviewData.description,
      questionRatings:questionRatings,
      selectedReviewTypes:selectedReviewTypes,
      selectedCourseOptions:selectedCourseOptions,
      selectedCenterOptions:selectedCenterOptions,
      selectedStaffOptions:selectedOptions,
      CourseOptions:courseOptions,
      CenterOptions:centerOptions,
      StaffOptions:staffOptions,
      recommendValue:recommend,
      friendInfoList:friendInfoList,
      student_id: user.userid,
      imageURL:imageURL
    };

	  
    axios({
      method: 'post',
      url: `${constant.base_url}/student/review_student.php?fun=postReviewData`,
      headers: { "Auth-Id": user.auth_id },
      data: reviewInfo
    }).then(function (response) {
      checkUserLogin(response);
      if (response.data.data.status === "1") {

        setSubmitStatus(true);
        toast.success(response.data.data.msg);
      } else {
        setSubmitStatus(false);
        toast.warn(response.data.data.msg);
      }
      setSubmitLoader(false);
    }).catch(function (error) {
    });

  }

  const checkUserLogin = (response) => {
    if (response.data.login.status === 0) {
      dispatch(logout());
      navigate("/login");
    }
  };
  const goToSetting = () => {
    navigate("/my-account?tab=settings");
  }
  const handleReviewAgain = ()=>{
    setRating(0);
    setReviewData({
        title: "",
        description: "",
        image: "",
    });
    setFriendInfoList( [
    { name: "", email: "", mobile: "" },
    { name: "", email: "", mobile: "" },
    { name: "", email: "", mobile: "" },
    ]);
     
    setSelectedReviewTypes([]);
    setRecommend(null);
    navigate("/reviews");
    getAllDataForm();
    setSubmitStatus(false);
  }
  useEffect(() => {
    getAllDataForm();
  },[]);

  return (
    <>
    {filterStatus && (
      <>
      <InnerHeader
        heading="My Reviews"
        txtSubHeading="We value your feedback on your experience with our institute, staff, and teachers. Please take a few minutes to share your thoughts. Your input is important and can help us improve our services and support future students."
        showButton={false}
        iconText="Add New Lead"
      />
      <Card className="account-container bg1 mt16 p20 pb48">
        {!submitStatus ? (
          <div className="review-container df fdc flx66">
            <div className="form-group-settings">
              <p className="fc15 fw6 fs16 ls1 lh18">Rate Us</p>
              <div className="mt8 v-center mb12">
                {[...Array(5)].map((_, index) =>
                  index < rating ? (
                    <MdOutlineStar
                      key={index}
                      className={`fs32 mr16 cp ${index < rating ? "fc12" : "fc18"}`}
                      onClick={() => handleRateClick(index)}
                    />
                  ) : (
                    <MdOutlineStarBorder
                      key={index}
                      className="fs32 mr16 cp fc18"
                      onClick={() => handleRateClick(index)}
                    />
                  )
                )}
                <span className="fs28 ">
                  {rating > 0 ? ratingDetails[rating - 1].emoji : ""}
                </span>
              </div>
            </div>

            <div className="desc-area w100 mb24">
              {rating > 0 && (
                <p className={`fc15 fs14 ls1 lh18 ${rating > 0 && "mt8"} mb12`}>
                  {rating > 0 ? ratingDetails[rating - 1].message : ""}
                </p>
              )}

              <textarea
                id="description"
                placeholder="Share details of your own experience"
                autoComplete="off"
                className="bg1 br4 fs14 w100 p16"
                onChange={handleChange}
                value={reviewData.description}
              />
            </div>

            <div className="upload-image mb32 mt12">
              <p className="fc15 fw6 fs16 ls1">Upload Photos</p>
              <p className="fs14 ls1 fc6 mt8 mb12 lh18">
                Share your photos to inspire others and showcase your experience with us!
              </p>
              <div className="image-upload-component">
                <ImageGallery setImageURL={setImageURL} ApiName="review_student.php" />
              </div>
            </div>

            <div className="brd-t2 ">
              <div className="rating-questions mb24 pt24">
                <div className="fc15 fs14 ls1 lh18 mb12">
                  We appreciate your time and input! Your feedback is essential in helping us enhance our services. Please take a moment to answer the following questions.
                </div>
                <div className="stepper-container step-mobile">
                  <div className="stepper v-center">
                    {questionRatings.map((_, index) => (
                      <React.Fragment key={index}>
                        <div
                          className={`step ${
                            index === currentStep ? "active" : ""
                          } ${
                            questionRatings[index].rating > 0 ? "completed" : ""
                          }`}
                          onClick={() => setCurrentStep(index)}
                        >
                          <div className="step-number">{index + 1}</div>
                        </div>
                        {index < questionRatings.length - 1 && (
                          <div
                            className={`line ${
                              questionRatings[index].rating > 0
                                ? "dashed-line"
                                : "solid-line"
                            }`}
                          ></div>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
                <div className="rating-questions-inner-mobile mt24">
                  <div className="question-section">
                    <p className="fs16 ls1 lh18 fw6">
                      <span className="mr4">Q{currentStep + 1}. </span>
                      {questionRatings[currentStep].question} {questionRatings[currentStep].mandatory_flag === "1" ? <span className="fc5">*</span> : ""}
                    </p>
                    {questionRatings[currentStep].type === "star" ? (
                      <div className="mt8 star-rating">
                        {[...Array(5)].map((_, index) =>
                          index < questionRatings[currentStep].rating ? (
                            <MdOutlineStar
                              key={index}
                              className="fs28 mr16 cp fc12"
                              onClick={() => handleStarClick(index)}
                            />
                          ) : (
                            <MdOutlineStarBorder
                              key={index}
                              className="fs28 mr16 cp fc18"
                              onClick={() => handleStarClick(index)}
                            />
                          )
                        )}
                      </div>
                    ) : ('')}
                  </div>
                  <div className="step-controls df jce">
                    <button
                      onClick={prevStep}
                      disabled={currentStep === 0}
                      className={`mr12 v-center fs14 br24 ls1 p8 ${
                        currentStep === 0 ? "not-allowed bg11 fc2 brd1" : "cp bg3 fc1"
                      }`}
                    >
                      <GrFormPreviousLink className="mr4" />
                      Previous
                    </button>
                    <button
                      onClick={nextStep}
                      disabled={currentStep === questionRatings.length - 1}
                      className={`v-center fs14 br24 ls1 p8 ${
                        currentStep === questionRatings.length - 1
                          ? "not-allowed bg11 fc2 brd1"
                          : "cp bg3 fc1"
                      }`}
                    >
                      Next
                      <GrFormNextLink className="ml4" />
                    </button>
                  </div>
                </div>
                <div className="ques-list mt16">
                  {questionRatings.map((item, index) => (
                    <div key={index} className="ques-item mt16 v-center">
                      <p className="fc15 fs14 ls1 flx66 lh18 fw6">
                        Q{index + 1}: {item.question} {item.mandatory_flag === "1" ? <span className="fc5">*</span> : ""}
                      </p>
                      <div className="review-star flx1">
                        {[...Array(5)].map((_, starIndex) => (
                          <span
                            key={starIndex}
                            className="fs24 mr16 cp"
                            onClick={() => handleRatingClick(index, starIndex + 1)}
                          >
                            {starIndex < item.rating ? (
                              <MdOutlineStar className="fc12" />
                            ) : (
                              <MdOutlineStarBorder className="fc17" />
                            )}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* {user.otherdata.stage !== "free" && (
                <div className="review-for brd-t2 mb24 pt24">
                  <div className="review-for">
                    <p className="fc15 fw6 fs16 ls1">
                      Review for <span className="fc5">*</span>
                    </p>
                    <div className="df fww mt8">
                      <label className="mr16 checkbox-label-review df">
                        <input
                          type="checkbox"
                          className="custom-checkbox-review"
                          checked={selectedReviewTypes.includes("course")}
                          onChange={() => handleReviewTypeChange("course")}
                        />
                        Course
                      </label>
                      <label className="mr16 checkbox-label-review">
                        <input
                          type="checkbox"
                          className="custom-checkbox-review"
                          checked={selectedReviewTypes.includes("center")}
                          onChange={() => handleReviewTypeChange("center")}
                        />
                        Center
                      </label>
                      <label className="mr16 checkbox-label-review">
                        <input
                          type="checkbox"
                          className="custom-checkbox-review"
                          checked={selectedReviewTypes.includes("instructor")}
                          onChange={() => handleReviewTypeChange("instructor")}
                        />
                        Instructor
                      </label>
                    </div>

                    {selectedReviewTypes.includes("course") && courseOptions.length > 1 && (
                      <div className="staff-info mt16">
                        <p className="fc15 fs14 ls1 mb12 fs14 lh18">
                          Please select course from the list
                        </p>
                        <ImageDropdown
                          labels="Course"
                          options={courseOptions}
                          onChange={handleCourseSelectionChange}
                        />
                      </div>
                    )}

                    {selectedReviewTypes.includes("center") && centerOptions.length > 1 && (
                      <div className="staff-info mt16">
                        <p className="fc15 fs14 ls1 mb12 fs14 lh18">
                          Please select center from the list
                        </p>
                        <ImageDropdown
                          labels="Center"
                          options={centerOptions}
                          onChange={handleCenterSelectionChange}
                        />
                      </div>
                    )}

                    {selectedReviewTypes.includes("instructor") && staffOptions.length > 0 && (
                      <div className="staff-info mt16">
                        <p className="fc15 fs14 ls1 mb12 fs14 lh18">
                          Please select instructor from the list
                        </p>
                        <ImageDropdown
                          labels="Instructor"
                          options={staffOptions}
                          onChange={handleSelectionChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )} */}

              <div className="recommend-friend brd-t2 pt24">
                <p className="fc15 fw6 fs16 ls1 lh18">
                  Would you recommend it to your friends and colleagues?
                  <span className="fc5">*</span>
                </p>
                <div className="df fww mt8">
                  <label className="mr16 checkbox-label-review df">
                    <input
                      type="checkbox"
                      className="custom-checkbox-review"
                      checked={recommend === "yes"}
                      onChange={() => handleRecommendationChange("yes")}
                    />
                    Yes
                  </label>
                  <label className="mr16 checkbox-label-review df">
                    <input
                      type="checkbox"
                      className="custom-checkbox-review"
                      checked={recommend === "no"}
                      onChange={() => handleRecommendationChange("no")}
                    />
                    No
                  </label>
                </div>
                {recommend === "yes" && (
                  <div className="friend-info mt16 ">
                    {friendInfoList.map((friend, index) => (
                      <div key={index} className="mb24 brd-bottom-dotted pb24">
                        <p className="mb12 fs14 fc2 fw6 ls1">
                          Recommendation {index + 1}:
                        </p>
                        <div className="v-center jcsb">
                          <div className="form-group-settings name w100 flx30">
                            <p className="fc15 fw6 fs14 ls1">
                              Name<span className="fc5">*</span>
                            </p>
                            <input
                              type="text"
                              id="name"
                              placeholder="Enter Name"
                              autoComplete="off"
                              className="bg1 br4 h40 mt8 fs14 w100 p16"
                              onChange={(e) => handleFriendChange(index, e)}
                              value={friend.name}
                            />
                          </div>
                          <div className="form-group-settings name w100 flx30">
                            <p className="fc15 fw6 fs14 ls1">
                              Email
                            </p>
                            <input
                              type="text"
                              id="email"
                              placeholder="Enter Email"
                              autoComplete="off"
                              className="bg1 br4 h40 mt8 fs14 w100 p16"
                              onChange={(e) => handleFriendChange(index, e)}
                              value={friend.email}
                            />
                          </div>
                          <div className="form-group-settings name w100 flx30">
                            <p className="fc15 fw6 fs14 ls1">
                              Mobile<span className="fc5">*</span>
                            </p>
                            <input
                              type="number"
                              id="mobile"
                              placeholder="Enter Mobile"
                              autoComplete="off"
                              className="bg1 br4 h40 mt8 fs14 w100 p16"
                              onChange={(e) => handleFriendChange(index, e)}
                              value={friend.mobile}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="df jce mb24">
                      <button
                        className="fs14 pl16 pr16 pt8 pb8 bg3 fc1 br24 ls2 cp v-center fs16"
                        onClick={addMoreFriends}
                      >
                        Add More
                        <AiFillPlusCircle className="ml8 fs20" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="rv-submit-btn mt20 box-center">
              {/* <button className="pl16 pr16 pt8 pb8 bg3 fc1 br24 ls2 cp v-center fs14">
                Submit Review
              </button> */}
              {!submitLoader && <button
                type="button"
                className="btn-blue bg1 br24 fs14 cp pl24 pr24 pt10 pb10 ls2"
                id={user.otherdata.stage}
                onClick={handleSubmit}>
                Submit
              </button>}
              {submitLoader && 
                  <div className="box-center mb12">
                    <SmallLoader className={"mb12"} />
                  </div>
              }
            </div>
          </div>
        
        ):
        <>
          <ThankYou/>
          <div className="mt24 box-center">
            <button
              type="button"
              className="btn-cancel"
              onClick={goToSetting}
            >
              Home
            </button>
            <button
              type="button"
              className="btn-blue bg1 br24 fs14 cp pl24 pr24 pt8 pb8 ls2"
              onClick={handleReviewAgain}
            >
              Review Again
            </button>
          </div>
        </>
        }
      </Card>
      <ToastContainer position="bottom-right" />
      </>
    )}
    </>
  );
};

export default Review;
